export default class naCertificate {
	constructor() {
		this.certificateContainer = document.getElementById('category-certificate-wrapper');
		this.header = document.querySelector('header');

		this.productsContainer = document.getElementById('account-products-xp');
		this.productsCatalogContainer = document.getElementById('Collection');
		this.partnerContainer = document.getElementById('partner-wrapper');
		this.certificateActiveContainer = document.getElementById('active-certificate-wrapper');

		this.certBtnWrappper = document.querySelector('.sertitficate-btn-wrapper');
		this.filterBtnCatalog = document.querySelector('.filter-btn');
		this.catalogProductFilter = document.querySelector('.product-filter');
		this.catalogTitle = document.querySelector('.catalog-title');

		this._initPartnerInfoAccessibility();
		this._btnEvents();
		this._initCatalogXpFilters();
		this._filterTrigger();
	}

	_initPartnerInfoAccessibility() {
		document.querySelectorAll('.partner-card').forEach((card, index) => {
			const button = card.querySelector('.partner-card__info-btn');
			const info = card.querySelector('.partner-card__info');
			const infoWrapper = card.querySelector('.partner-card__info--wrapper');

			if (!button || !info) return;

			if (!info.id) info.id = `partner-card-info-${index + 1}`;

			infoWrapper?.setAttribute('tabindex', '0');
			button.setAttribute('aria-controls', info.id);
			button.setAttribute('aria-expanded', info.style.display === 'block' ? 'true' : 'false');
		});
	}

	_closePartnerInfo(info, returnFocus = false) {
		if (!info) return;

		info.style.display = 'none';
		const button = document.querySelector(`.partner-card__info-btn[aria-controls="${info.id}"]`);
		button?.setAttribute('aria-expanded', 'false');
		if (returnFocus) button?.focus();
	}

	_closeAllPartnerInfo() {
		document.querySelectorAll('.partner-card__info').forEach(info => this._closePartnerInfo(info));
	}

	_openPartnerInfo(button) {
		const info = button.nextElementSibling;
		if (!info || !info.classList.contains('partner-card__info')) return;

		this._closeAllPartnerInfo();
		info.style.display = 'block';
		button.setAttribute('aria-expanded', 'true');
	}

	_handlePartnerInfoKeydown = (event) => {
		if (event.key !== 'Escape') return;

		const openInfo = document.querySelector('.partner-card__info[style*="display: block"]');
		if (!openInfo) return;

		event.preventDefault();
		this._closePartnerInfo(openInfo, true);
	};

	_hideCatalog() {
		if (!this.certificateContainer) return;

		this._fadeOut(this.certificateContainer, 400);

		const rect = this.certificateContainer.getBoundingClientRect();
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		const top = rect.top + scrollTop - 250;

		window.scrollTo({
			top: top,
			behavior: "smooth"
		});
	}

	_showCatalog() {
		if (!this.certificateContainer) return;

		this._fadeIn(this.certificateContainer, 300);

		const rect = this.certificateContainer.getBoundingClientRect();
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		const top = rect.top + scrollTop - 250;

		window.scrollTo({
			top: top,
			behavior: "smooth"
		});
	}

	_btnEvents() {
		document.addEventListener('keydown', this._handlePartnerInfoKeydown);

		document.addEventListener('click', (e) => {
			// .category-partners-js click
			const partnerBtn = e.target.closest('.category-partners-js');
			if (partnerBtn) {
				e.preventDefault();
				this._hideCatalog();

				const categoryId = partnerBtn.getAttribute('data-category-id');
				const targetPartnerWrapper = document.getElementById('partner-wrapper-' + categoryId);
				if (targetPartnerWrapper) {
					this._fadeIn(targetPartnerWrapper, 300);
				}
			}

			// .js-back-to-category click
			const backBtn = e.target.closest('.js-back-to-category');
			if (backBtn) {
				const tab = backBtn.closest('.certificate-tab');
				if (tab) {
					this._fadeOut(tab, 400);
				}
				this._showCatalog();
			}

			// .partner-card__info-btn click
			const infoBtn = e.target.closest('.partner-card__info-btn');
			if (infoBtn) {
				this._openPartnerInfo(infoBtn);
			}

			// .partner-card__info .close click
			const closeBtn = e.target.closest('.partner-card__info .close');
			if (closeBtn) {
				this._closePartnerInfo(closeBtn.closest('.partner-card__info'));
			}
		});
	}

	_fadeIn(el, duration) {
		el.style.opacity = 0;
		el.style.display = 'block';
		el.style.transition = `opacity ${duration}ms`;
		setTimeout(() => {
			el.style.opacity = 1;
		}, 10);
	}

	_fadeOut(el, duration) {
		el.style.opacity = 1;
		el.style.transition = `opacity ${duration}ms`;
		el.style.opacity = 0;
		setTimeout(() => {
			el.style.display = 'none';
		}, duration);
	}

	_initCatalogXpFilters() {
		const filtersWrapper = document.querySelector('.catalog-main__filters--xp');
		const selectEl = document.querySelector('#select-product-xp');
		const certificateBlock = document.querySelector('.catalog__xp-group--certificates');
		const productsBlock = document.querySelector('.catalog__xp-group--products');

		if (!filtersWrapper || !selectEl) return;

		const filterButtons = filtersWrapper.querySelectorAll('.catalog-main__filters-item');
		// tom-select before init or not init
		let ts = null;


		if (selectEl.classList.contains('tomselected')) {
			ts = selectEl.tomselect;
		}

		const updateBlocks = (value) => {
			if (value === 'all-xp') {
				certificateBlock && (certificateBlock.style.display = 'block');
				productsBlock && (productsBlock.style.display = 'block');
			} else if (value === 'certificate') {
				certificateBlock && (certificateBlock.style.display = 'block');
				productsBlock && (productsBlock.style.display = 'none');
			} else if (value === 'all-xp-product') {
				certificateBlock && (certificateBlock.style.display = 'none');
				productsBlock && (productsBlock.style.display = 'block');
			}
		};

		const setActiveButton = (value) => {
			filterButtons.forEach(btn => {
				if (btn.dataset.value === value) {
					btn.classList.add('is-active-filter');
				} else {
					btn.classList.remove('is-active-filter');
				}
			});
		};

		const initialValue = ts ? ts.getValue() : selectEl.value;
		if (initialValue) {
			setActiveButton(initialValue);
			updateBlocks(initialValue);
		}

		filterButtons.forEach(btn => {
			btn.addEventListener('click', () => {
				const value = btn.dataset.value;
				setActiveButton(value);
				if (ts) {
					ts.setValue(value, true);
				} else {
					selectEl.value = value;
				}
				updateBlocks(value);
			});
		});

		if (ts) {
			ts.on('change', (value) => {
				setActiveButton(value);
				updateBlocks(value);
			});
		} else {
			selectEl.addEventListener('change', (e) => {
				const value = e.target.value;
				setActiveButton(value);
				updateBlocks(value);
			});
		}
	}

	_filterTrigger() {
		const filterItems = document.querySelectorAll('#certificates-filter-items input[name="category"]');
		const partnerCards = document.querySelectorAll('.partner-card');

		filterItems.forEach(input => {
			input.addEventListener('change', (e) => {
				const currentInput = e.target;
				const isAll = currentInput.value === 'all';

				if (isAll) {
					if (currentInput.checked) {
						filterItems.forEach(item => {
							if (item !== currentInput) {
								item.checked = false;
								item.closest('.filter__item')?.classList.remove('is-active-filter');
							}
						});
					} else {
						currentInput.checked = true;
					}
				} else {
					const allInput = Array.from(filterItems).find(i => i.value === 'all');
					if (currentInput.checked) {
						if (allInput) {
							allInput.checked = false;
							allInput.closest('.filter__item')?.classList.remove('is-active-filter');
						}
					}
				}

				filterItems.forEach(item => {
					if (item.checked) {
						item.closest('.filter__item')?.classList.add('is-active-filter');
					} else {
						item.closest('.filter__item')?.classList.remove('is-active-filter');
					}
				});

				const selectedCategories = Array.from(filterItems)
					.filter(i => i.checked)
					.map(i => i.value);

				if (selectedCategories.length === 0) {
					const allInput = Array.from(filterItems).find(i => i.value === 'all');
					if (allInput) {
						allInput.checked = true;
						allInput.closest('.filter__item')?.classList.add('is-active-filter');
						selectedCategories.push('all');
					}
				}

				partnerCards.forEach(card => {
					if (selectedCategories.includes('all')) {
						card.style.display = 'block';
					} else {
						const cardCategoryId = card.dataset.categoryId;
						if (selectedCategories.includes(cardCategoryId)) {
							card.style.display = 'block';
						} else {
							card.style.display = 'none';
						}
					}
				});
			});
		});
	}

}
